import React from 'react';

const CopyCommand = ({ path }) => {
  const handleCopy = () => {
    const json = { path };

    navigator.clipboard.writeText(JSON.stringify(json, null, 2))
      .then(() => alert('Copied to clipboard!'))
      .catch(err => console.error('Failed to copy: ', err));
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#4CAF50',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)'
  };

  const hoverStyle = {
    backgroundColor: '#45a049'
  };

  const [hovered, setHovered] = React.useState(false);

  return (
    <button
      onClick={handleCopy}
      style={{ ...buttonStyle, ...(hovered ? hoverStyle : {}) }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      📋 Copy JSON
    </button>
  );
};

export default CopyCommand;
